import {
    WISHLIST_CHANGE_QUANTITY,
    WISHLIST_UPDATE,
    WISHLIST_ADD_TO_CART,
} from '../Services/WishList.service';
const DEFAULT_STATE = {
    id: '',
    items: [],
};
 
export const wishList = (state = DEFAULT_STATE, action) => {
    switch (action.type) {
        case WISHLIST_CHANGE_QUANTITY:
            return {
                ...state,
                items: state.items.map((wish) =>
                    wish.articleNumber === action.articleNumber
                        ? { ...wish, quantity: action.quantity }
                        : wish
                ),
            };
        case WISHLIST_UPDATE:
            return {
                ...state,
                items: action.items,
            };
        case WISHLIST_ADD_TO_CART:
            return {
                ...state,
                payload: action.payload,
            };
        default:
            return state;
    }
};